<template>
  <div id="BattleDialog">
    <el-dialog
      v-if="visible"
      class="battleDialog"
      top="30vh"
      :visible.sync="visible"
      :show="visible"
      :show-close="false"
      :close-on-press-escape="false"
      :close-on-click-modal="closeOnClickModal"
      append-to-body>
      <div>
        <div class="tipTitle" v-if="type === 2 || type === 3">
          {{tipTitle}}
        </div>
        <div class="content">
          {{content}}
        </div>
        <div class="btnBox" v-if="type === 1 || type === 3">
          <div class="confirm cursor" @click="yesBtn">{{ okTxt }}</div>
        </div>
        <div class="btnBox2" v-else>
          <div class="cancel cursor" @click="noBtn">{{cancelTxt}}</div>
          <div class="confirm cursor" @click="yesBtn">{{ okTxt }}</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    width: {
      type: [String, Number],
      default: 1000
    },
    hasCloseIcon: { type: Boolean, default: true },
    top: {
      type: [String, Number],
      default: '100px'
    },
    // show: { type: Boolean, default: false },
    closeOnClickModal: { type: Boolean, default: false }
    // type: {
    //   type: Number, default: 1
    // }
  },
  name: 'BattleDialog',
  data () {
    return {
      visible: false,
      content: '',
      tipTitle: '',
      confirm: null,
      type: 1,
      okTxt: 'OK',
      cancelTxt: 'Cancel',
      cancel: null
    }
  },
  methods: {
    noBtn () {
      this.cancel && this.cancel()
      this.visible = false
    },
    yesBtn () {
      this.confirm && this.confirm()
      this.visible = false
    }
  }
}
</script>

<style lang="scss">
.battleDialog{
  .tipTitle{
    font-family: MicrosoftYaHeiUI-Bold;
    font-size: 18px;
    color: #1C1C1C;
    letter-spacing: 0;
    font-weight: 600;
    word-break: keep-all;
    margin-bottom: 18px;
  }
  .content{
    font-family: MicrosoftSansSerif;
    font-size: 18px;
    color: #1C1C1C;
    letter-spacing: 0;
    overflow: hidden;
    word-break: keep-all;
    white-space: pre-wrap;
  }
  .btnBox{
    .confirm{
      background: #3C65D6;
      border: 2px solid #001A61;
      box-shadow: inset 0 -5px 0 0 #0044FF;
      border-radius: 20px;
      height: 40px;
      box-sizing: border-box;
      margin-top: 50px;
      font-family: MicrosoftYaHeiUI-Bold;
      font-size: 16px;
      color: #FFFFFF;
      letter-spacing: 0;
      font-weight: 600;
      text-align: center;
      line-height: 36px;
    }
  }
  .btnBox2{
    display: flex;
    justify-content: space-between;
    margin-top: 40px;
    div {
      width: 192px;
      height: 40px;
      line-height: 36px;
    }
    .cancel{
      box-sizing: border-box;
      border: 2px solid #001A61;
      border-radius: 20px;
      font-family: MicrosoftYaHeiUI-Bold;
      font-size: 16px;
      color: #001A61;
      letter-spacing: 0;
      text-align: center;
      font-weight: 600;
    }
    .confirm{
      box-sizing: border-box;
      background: #3C65D6;
      border: 2px solid #001A61;
      box-shadow: inset 0 -5px 0 0 #0044FF;
      border-radius: 20px;
      font-family: MicrosoftYaHeiUI-Bold;
      font-size: 16px;
      color: #FFFFFF;
      letter-spacing: 0;
      text-align: center;
    }
  }
  .el-dialog{
    width: 480px;
    box-sizing: border-box;
    background: #FFFFFF;
    border: 4px solid #001A61;
    border-radius: 32px;
  }
  .el-dialog__header{
    display: none;
  }
  .el-dialog__body{
    box-sizing: border-box;
    padding: 40px;
  }
}
</style>



// WEBPACK FOOTER //
// src/plugin/BattleDialog/src/main.vue